import React, { Component } from "react";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
import DraggerIcon from "../../../icons/draggericon";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//moment import
import moment from "moment-timezone";
//Service import
import service from "../../../services";

//Loader import
import Loader from "../../loader";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import EditIcon from "../../../icons/EditIcon";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};
let sub;
let statusFilterList = [];

class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      getAllProductCouponListDetails: [],
      getAllProductCouponListtotaldocs: [],
      offset: 0,
      perPage: 20,
      currentPage: 1,
      statusArray: [
        { assign: "Live", list: 1, value: false },
        { assign: "Disable", list: 2, value: false },
      ],
      data: [
        {
          label: "product list",
          Content: "This is content for Tab 1",
        },
      ],
      isAscending:true,
      isDraggable: false,
    };
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    this.getAllProductCouponList();
    this.getAllProductCouponEvent();
    this.setState({
      loaderFlag: true,
    });
  };
  componentWillUnmount = () => {
    sub.unsubscribe();
    this.setState({getAllProductCouponListtotaldocs:[]})
  };

  getAllProductCouponEvent = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|products|getList":
          this.setState(
            {
              getAllProductCouponListDetails: response.data,
              getAllProductCouponListtotaldocs: response.data.docs,
              // getAllProductCouponListtotaldocs: response.data.docs.sort((a,b) => {
              //   if(a !== undefined && b !== undefined){
              //       if (a.name.toLowerCase().trim() < b.name.toLowerCase().trim()) return -1;
              //       if (a.name.toLowerCase().trim() > b.name.toLowerCase().trim()) return 1;
              //       return 0;
              //   }
              // }),
            },
            () => {
              this.setState({
                loaderFlag: false,
                pageCount: Math.ceil(
                  response.data.totalDocs / this.state.perPage
                ),
              });
            }
          );
          let data = []
          response.data.docs.map((item, i) => {
            data.push({'productId': item._id, 'sortIndex': i})
          })
          this.props.productData({order:data})
          break;
      }
    });
  };

  getAllProductCouponList = () => {
    this.apiserve.sendevent("ticketCms|products|getList", {page: 1,
      limit: 500,});
  };
  editTalkEventListData = (item) => {
    this.props.ProductEditList(item);
    this.props.history.push({ pathname: "/product-detail" });
  };
  StatusFilter = (e, selectedInex, isClearStatusType = false) => {
    let index = selectedInex;
    let event = e && e.target && e.target.checked;
    let approvePassList = [...this.state.statusArray];
    approvePassList.forEach((key, i) => {
      if (i === index) {
        approvePassList[i].value = event;
      }
      if (isClearStatusType) {
        approvePassList[i].value = false;
        statusFilterList = [];
      }
    });
    this.setState(
      {
        ...this.state,
        statusArray: approvePassList,
        currentPage: 0,
      },
      () => {
        if (event) {
          if (index !== null) {
            statusFilterList = [
              ...statusFilterList,
              this.state.statusArray[index].list,
            ];
          }
        } else {
          if (index !== null) {
            let tempArray = statusFilterList.filter(
              (d) => d !== this.state.statusArray[index].list
            );
            statusFilterList = tempArray;
          }
        }
        this.getFilmFilter(
          this.state.offset,
          this.state.perPage,
          isClearStatusType
        );
      }
    );
    if(approvePassList.filter(_ => _.value).length > 0){
      this.props.isDisable(true)
    } else {
      this.props.isDisable(false)
    }
  };

  getFilmFilter = (skip, limit, isClearStatusType) => {
    let data = {
      page: 1,
      limit: limit,
    };

    if (!isClearStatusType && statusFilterList && statusFilterList.length) {
      data.status = statusFilterList;
    }

    this.apiserve.sendevent("ticketCms|products|getList", data);
  };

  nameFilter = () => {
    let isAscending = !this.state.isAscending
    let productList = this.state.getAllProductCouponListtotaldocs.sort((a,b) => {
      if(a !== undefined && b !== undefined){
        if(isAscending){
          if (a.name.toLowerCase().trim() < b.name.toLowerCase().trim()) return -1;
          if (a.name.toLowerCase().trim() > b.name.toLowerCase().trim()) return 1;
          return 0;
        } else {
          if (a.name.toLowerCase().trim() > b.name.toLowerCase().trim()) return -1;
          if (a.name.toLowerCase().trim() < b.name.toLowerCase().trim()) return 1;
          return 0;
        }
      }
    })
    let data = []
     productList.map((item, i) => {
      data.push({'productId': item._id, 'sortIndex': i})
    })
    this.props.productData({order:data})
    this.setState({
      getAllProductCouponListtotaldocs:productList,
      isAscending:isAscending
    })
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllProductCouponListtotaldocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        productId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    console.log(data,"data");
    this.props.productData(data)
    // this.apiserve.sendevent("ticketCms|products|changeOrder", data);
    this.setState({ getAllProductCouponListtotaldocs: arr });
  };

  render() {
    const { getAllProductCouponListtotaldocs, statusArray } = this.state;
    return (
      <>
        <table>
          <thead>
          <tr>
            <th></th>
            <th>
              {statusFilterList && statusFilterList.length === 0 ? <span className="d_flex d_flex_align_center pointer" onClick={() => this.nameFilter()}>
                Product Name
                {!this.state.isAscending ? (
                  <FilterActiveIcon />
                ) : (
                  <FilterIcon />
                )}
              </span> :
              <span className="d_flex d_flex_align_center pointer">
                Product Name
              </span>}
            </th>
            <th>Product Group</th>
            <th>Price</th>
            <th>Created Date (MT)</th>
            <th>Last Updated Date (MT)</th>
            <th>Visibility</th>
            <th>Availability</th>
            <th></th>
            <th>
              <span className="d_flex d_flex_align_center">
                Status
                {statusFilterList && statusFilterList.length ? (
                  <FilterActiveIcon />
                ) : (
                  <FilterIcon />
                )}
              </span>
              <div className="tabelData_popup">
                <form>
                  <div className="customCheck">
                    <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                      <p
                        className="link"
                        onClick={() => this.StatusFilter(null, null, true)}
                      >
                        Clear All
                      </p>
                    </div>

                    <div className="customCheckBox">
                      {statusArray.map((item, i) => (
                        <div className="customCheckBox">
                          <input
                            type="checkbox"
                            id={"status1" + item.list}
                            name={"status1" + item.list}
                            value={item.list ? true : false}
                            checked={item.value ? true : false}
                            onClick={(e) => this.StatusFilter(e, i)}
                          />
                          <label htmlFor={"status1" + item.list}>
                            {item.assign}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </form>
              </div>
            </th>
          </tr>
          </thead>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                {getAllProductCouponListtotaldocs &&
                  getAllProductCouponListtotaldocs.map((item, i) => (
                    <>
                    <Draggable
                      key={item._id}
                      draggableId={item._id}
                      index={i}
                      isDragDisabled={statusFilterList && statusFilterList.length > 0}
                    >
                      {(provided, snapshot) => (
                    <tr
                      className={item.status === 2 ? "disable" : ""}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <td>{statusFilterList && statusFilterList.length === 0 && <span className="cat_drag d_flex">
                                    <DraggerIcon />
                                  </span>}</td>
                      <td>
                        <strong>{item.name}</strong>
                      </td>
                      <td>
                        <p>{item.group === 'ticketing' || item.group === 'newTicketing' ? 'Public' : item.group === 'presale' ? 'PreSale' : item.group === 'boxoffice' ? 'Boxoffice' : ''}</p>
                      </td>
                      {/* <td>
                        <p>{item.accessType}</p>
                      </td> */}
                      <td>
                        <p>${item.price}</p>
                      </td>
                      <td>
                        <p>{moment.tz(item.createdAt, "US/Mountain").format("MM/DD/YYYY")}</p>
                      </td>
                      <td>
                        <p>{moment.tz(item.updatedAt, "US/Mountain").format("MM/DD/YYYY")}</p>
                      </td>
                      <td>
                        {item.group === 'presale' ? item.adminStatus === 1 ? 'Admin Only' : 'Standard' : '-'}
                      </td>
                      <td>
                        {item.globalSoldOut ? 'Sold Out' : 'On Sale'}
                      </td>
                      <td>
                        <span className="pointer"  onClick={() => this.editTalkEventListData(item._id)}><EditIcon /></span>
                      </td>
                      <td>
                        <p>
                          {item.status === 1
                            ? "Live"
                            : item.status === 2
                            ? "Disabled"
                            : ""}
                        </p>
                      </td>
                    </tr>
                     )}
                     </Draggable>
                  </>
                ))}
              </tbody>)}
            </Droppable>
          </DragDropContext>
        </table>
        {/* Loader */}
        {this.state.loaderFlag ? <Loader /> : ""}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
